/**
 * Public Base URL utility
 * Default: https://fivelensenneagram.com
 */

export const DEFAULT_PUBLIC_BASE_URL = 'https://www.fivelensenneagram.com';

export function getPublicBaseUrl(): string {
  if (typeof process !== 'undefined' && process.env?.PUBLIC_BASE_URL) {
    const trimmed = process.env.PUBLIC_BASE_URL.replace(/\/+$/, '');
    if (trimmed === 'https://fivelensenneagram.com' || trimmed === 'http://fivelensenneagram.com') {
      console.warn('Warning: getPublicBaseUrl() rewrote apex PUBLIC_BASE_URL to canonical www domain');
      return DEFAULT_PUBLIC_BASE_URL;
    }
    return trimmed;
  }
  return DEFAULT_PUBLIC_BASE_URL;
}

export function getCanonicalUrl(pathname: string = '/'): string {
  const base = getPublicBaseUrl().replace(/\/+$/, '');
  const cleanPath = pathname.startsWith('/') ? pathname : `/${pathname}`;
  return `${base}${cleanPath}`;
}

const LOCALE_PREFIX = /^\/(en[-_]US|en[-_]GB|en[-_]ZA)(?=$|\/|\?|#)/i;

export function getLocaleFromPath(path: string): string | null {
  const match = path.match(LOCALE_PREFIX);
  if (!match) return null;
  const raw = match[1].toLowerCase().replace('-', '_');
  if (raw === 'en_za') return 'en_ZA';
  if (raw === 'en_gb') return 'en_GB';
  if (raw === 'en_us') return 'en_US';
  return match[1];
}

export function hasLocalePrefix(path: string): boolean {
  return LOCALE_PREFIX.test(path);
}

export function stripLocalePrefix(path: string): string {
  const stripped = path.replace(LOCALE_PREFIX, '');
  if (!stripped) return '/';
  if (stripped.startsWith('/') || stripped.startsWith('http')) return stripped;
  return '/' + stripped;
}
